import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Col, Row } from 'react-bootstrap';
import { getEquipmentNameList, getDeviceList } from '../../../actions/eg-kanban';
import { getOperatorList } from '../../../actions/eg-kanban';
import EquipmentColumn from './EquipmentColumn';

const EquipmentColumns = (props) => {
    const { farmId, draggableType, refresh } = props;

    useEffect(() => {
        props.actions.getVehicleEquipmentList(farmId);
        props.actions.getImplementEquipmentList(farmId);
        props.actions.getPhoneDeviceList(farmId);
        props.actions.getOperatorList({ farmId });
    }, [refresh]);

    return (<div className="kanban-options">
        <Row lg={12} md={12} sm={12} className="m-0 h-50 pb-1 ">
            <Col lg={6} md={6} sm={6} className="kanban-option-item">
                <EquipmentColumn type="vehicle" draggableType={draggableType} />
            </Col>
            <Col lg={6} md={6} sm={6} className="kanban-option-item">
                <EquipmentColumn type="implement" draggableType={draggableType} />
            </Col>
        </Row>
        <Row lg={12} md={12} sm={12} className="m-0 h-50 pt-1">
            <Col lg={6} md={6} sm={6} className="kanban-option-item">
                <EquipmentColumn type="device" draggableType={draggableType} />
            </Col>
            <Col lg={6} md={6} sm={6} className="kanban-option-item">
                <EquipmentColumn type="operator" draggableType={draggableType} />
            </Col>
        </Row>
    </div>
    )
}

const mapStateToProps = state => ({
    refresh: state.egKanban.refresh
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        getVehicleEquipmentList: (farmId) =>
            getEquipmentNameList({ farmId, equipmentType: 'vehicle' }),
        getImplementEquipmentList: (farmId) =>
            getEquipmentNameList({ farmId, equipmentType: 'implement' }),
        getPhoneDeviceList: farmId => getDeviceList({ farmId, deviceType: 'phone' }),
        getOperatorList,
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(EquipmentColumns);